module.exports = __webpack_public_path__ + "img/art-25.97bf5300.png";